/**
 * fr locale — French (France, fr-FR)
 *
 * Extracted from all frontend source files (Issue #18 — i18n).
 * Falls back to pt-BR for any missing key.
 */
export const fr: Record<string, string> = {
  // ---------------------------------------------------------------------------
  // common — shared strings used across multiple pages/components
  // ---------------------------------------------------------------------------
  'common.loading': 'Chargement...',
  'common.checkSpam': 'Si vous ne le recevez pas dans quelques minutes, verifiez votre dossier spam ou courrier indesirable.',
  'common.checkSpamThirdParty': 'Sils ne le reçoivent pas dans quelques minutes, demandez-leur de verifier leur dossier spam ou courrier indesirable.',
  'common.close': 'Fermer',
  'common.cancel': 'Annuler',
  'common.filter': 'Filtrer',
  'common.from': 'De',
  'common.to': 'À',
  'common.all': 'Tous',
  'common.type': 'Type',
  'common.status': 'Statut',
  'common.origin': 'Origine',
  'common.date': 'Date',
  'common.file': 'Fichier',
  'common.value': 'Valeur',
  'common.confidence': 'Confiance',
  'common.source': 'Source',
  'common.field': 'Champ',
  'common.yes': 'Oui',
  'common.no': 'Non',
  'common.email': 'E-mail',
  'common.processing': 'Traitement...',
  'common.error': 'Erreur',
  'common.dash': '—',
  'common.filterPlaceholder': 'Filtrer...',
  'common.importId': 'Import ID',
  'common.corrected': 'corrigé',
  'common.errorPrefix': 'Erreur : ',

  // Document type labels
  'common.doctype.nfe': 'NF-e',
  'common.doctype.nfse': 'NFS-e',
  'common.doctype.nfcom': 'NFCom',
  'common.doctype.email': 'E-mail',
  'common.doctype.zip': 'ZIP',
  'common.doctype.unknown': 'Inconnu',

  // Legal document labels
  'common.legal.terms': "Conditions d'utilisation",
  'common.legal.privacy': 'Politique de confidentialité',
  'common.legal.cookies': 'Politique de cookies',
  'common.legal.termsShort': 'Conditions',
  'common.legal.privacyShort': 'Confidentialité',
  'common.legal.cookiesShort': 'Cookies',
  'common.legal.custodia': 'Conditions de Conservation',
  'common.legal.back': 'Retour',

  // ---------------------------------------------------------------------------
  // app — App.tsx
  // ---------------------------------------------------------------------------
  'app.loading': 'Chargement...',

  // ---------------------------------------------------------------------------
  // home — Home.tsx
  // ---------------------------------------------------------------------------
  'home.title': 'Aura Nota',
  'home.subtitle': 'Outil de capture et d\'extraction structurée de factures fiscales brésiliennes (NFS-e, NF-e et télécom).',
  'home.card.upload.title': 'Téléversement',
  'home.card.upload.desc': 'Recevoir des PDF, XML et images de documents.',
  'home.card.extraction.title': 'Extraction',
  'home.card.extraction.desc': 'OCR, XML et LLM pour lire les champs automatiquement.',
  'home.card.review.title': 'Révision',
  'home.card.review.desc': 'Interface humaine pour valider et corriger les données.',
  'home.hero.title': 'Aura Nota — Capture et extraction intelligente de factures fiscales',
  'home.hero.subtitle': 'Automatisez la lecture des NFS-e, NFCom et recus avec l\'IA. Extrayez, validez et exportez les champs fiscaux en quelques secondes.',
  'home.hero.cta.signup': 'Commencer gratuitement',
  'home.hero.cta.pricing': 'Voir les forfaits',
  'home.features.title': 'Fonctionnalites',
  'home.features.extraction.title': 'Extraction Automatique',
  'home.features.extraction.desc': 'Champs fiscaux extraits en quelques secondes avec l\'IA',
  'home.features.lgpd.title': 'Conformite LGPD',
  'home.features.lgpd.desc': 'Serveur dans l\'Union européenne sous DPA, chiffrement en transit et au repos, DSAR et consentement integres',
  'home.features.multilayout.title': 'Multi-format',
  'home.features.multilayout.desc': 'NFS-e, NFCom, recus et plus',
  'home.features.export.title': 'Export Structure',
  'home.features.export.desc': 'JSON, CSV et integration avec votre ERP',
  'home.pricing.teaser.title': 'Forfaits a partir de R$ 0',
  'home.pricing.teaser.desc': 'Commencez gratuitement et evoluez selon vos besoins. Sans carte de credit.',
  'home.pricing.teaser.cta': 'Voir les forfaits',
  'home.footer.login': 'Connexion',
  'home.footer.signup': 'Inscription',
  'home.footer.pricing': 'Forfaits',
  'home.footer.dsar': 'DSAR',
  'home.footer.terms': 'Conditions',
  'home.footer.privacy': 'Confidentialite',
  // Issue #594: sections de la landing publique (visiteur).
  'home.howItWorks.title': 'Comment ça marche',
  'home.howItWorks.step1.title': 'Envoyez vos factures',
  'home.howItWorks.step1.desc': 'Transférez les documents vers votre e-mail de capture dédié ou téléversez manuellement des PDF, XML et images.',
  'home.howItWorks.step2.title': 'Extraction automatique',
  'home.howItWorks.step2.desc': 'Le XML est lu directement ; les PDF et images passent par l\'OCR et l\'IA pour extraire les champs fiscaux.',
  'home.howItWorks.step3.title': 'Révisez en sécurité',
  'home.howItWorks.step3.desc': 'Les champs à faible confiance vont dans la file de révision — chaque correction est consignée dans la piste d\'audit.',
  'home.howItWorks.step4.title': 'Exportez vers votre ERP',
  'home.howItWorks.step4.desc': 'Téléchargez les données structurées en JSON ou CSV et envoyez-les à votre système comptable ou à votre comptable.',
  'home.captures.title': 'Ce que nous capturons',
  'home.captures.nfse.title': 'NFS-e',
  'home.captures.nfse.desc': 'Factures de services en PDF et XML dans les nombreux layouts et fournisseurs municipaux.',
  'home.captures.nfcom.title': 'NFCom / NFT (modèle 62)',
  'home.captures.nfcom.desc': 'Factures télécom avec des modèles dédiés aux principaux opérateurs et un layout générique.',
  'home.captures.nfe.title': 'NF-e et NFC-e',
  'home.captures.nfe.desc': 'XML de factures de marchandises et de coupons électroniques lus directement, sans OCR.',
  'home.captures.others.title': 'Reçus, ZIP et e-mail',
  'home.captures.others.desc': 'Reçus et documents numérisés via OCR/IA, ainsi que les pièces jointes dans les fichiers ZIP et e-mails (.eml).',
  'home.personas.title': 'Pour qui',
  'home.personas.company.title': 'Entreprises',
  'home.personas.company.desc': 'La finance transfère les factures à l\'e-mail de capture et exporte les données prêtes pour l\'ERP ou le comptable.',
  'home.personas.accounting.title': 'Cabinets comptables',
  'home.personas.accounting.desc': 'Plan Team avec jusqu\'à 5 utilisateurs, profil comptable et documents séparés par client.',
  'home.personas.dev.title': 'Développeurs',
  'home.personas.dev.desc': 'Intégrez la capture à votre système via l\'API — disponible sur le plan Enterprise, sur demande.',
  'home.diff.title': 'Différenciateurs',
  'home.diff.dedup.title': 'Déduplication automatique',
  'home.diff.dedup.desc': 'La même facture n\'entre jamais deux fois : nous détectons les doublons par le hash du fichier et par la clé d\'accès de la NF.',
  'home.diff.audit.title': 'Piste d\'audit',
  'home.diff.audit.desc': 'Chaque action sur un document est consignée — qui l\'a faite, quand et pourquoi (LGPD).',
  'home.faq.title': 'Questions fréquentes',
  'home.faq.q1': 'Quels types de documents Aura Nota traite-t-il ?',
  'home.faq.a1': 'NFS-e (PDF et XML de nombreux layouts municipaux), factures NFCom/NFT modèle 62, NF-e et NFC-e en XML, reçus et autres PDF ou images via OCR. Les fichiers ZIP et les e-mails avec pièces jointes sont également acceptés.',
  'home.faq.q2': 'Comment fonctionne la capture par e-mail dédié ?',
  'home.faq.a2': 'Chaque organisation reçoit une adresse de capture exclusive. Il suffit de transférer les e-mails avec les factures en pièce jointe — elles entrent automatiquement dans la file de traitement.',
  'home.faq.q3': 'Conservez-vous les fichiers originaux ?',
  'home.faq.a3': 'Non. Le fichier est traité puis supprimé ; nous ne conservons que les données extraites et les métadonnées pendant la durée de rétention configurable de votre organisation (par défaut : 5 ans).',
  'home.faq.q4': 'Faut-il une carte de crédit pour commencer ?',
  'home.faq.a4': 'Non. Le plan Free inclut 10 documents par mois et ne demande pas de carte. Passez à un plan supérieur quand vous avez besoin de plus de volume ou d\'utilisateurs.',
  'home.faq.q5': 'Puis-je annuler à tout moment ?',
  'home.faq.a5': 'Oui. L\'annulation prend effet à la fin de la période déjà payée — sans facturation immédiate ni pénalité.',
  'home.faq.q6': 'Où sont hébergées mes données ?',
  'home.faq.a6': 'Sur un serveur dans l\'Union européenne (France), sous contrat de traitement de données (DPA) et Clauses Contractuelles Types, en conformité avec la LGPD. Les détails sont dans la Politique de Confidentialité.',
  'home.pricing.teaser.ctaSignup': 'Créer un compte gratuit',

  // ---------------------------------------------------------------------------
  // login — Login.tsx
  // ---------------------------------------------------------------------------
  'login.title': 'Connexion',
  'login.subtitle': 'Accédez à votre compte Aura Nota.',
  'login.email': 'E-mail',
  'login.password': 'Mot de passe',
  'login.submit': 'Connexion',
  'login.submitting': 'Connexion...',
  'login.noAccount': "Vous n'avez pas de compte ?",
  'login.signupLink': 'Inscrivez-vous',
  'login.error.auth': 'Erreur d\'authentification.',
  'session.expired': 'Votre session a expiré. Veuillez vous reconnecter.',
  'session.loginAgain': 'Se reconnecter',

  // ---------------------------------------------------------------------------
  // layout — Layout.tsx
  // ---------------------------------------------------------------------------
  'layout.brand': 'Aura Nota',
  'layout.nav.home': 'Accueil',
  'layout.nav.upload': 'Téléversement',
  'layout.nav.documents': 'Documents',
  'layout.nav.billing': 'Facturation',
  'layout.nav.quota': 'Quota',
  'layout.nav.subscription': 'Abonnement',
  'layout.nav.myAccount': 'Mon Compte',
  'layout.account': 'Compte',
  'layout.logout': 'Déconnexion',
  'layout.login': 'Connexion',
  'layout.footer.terms': "Conditions d'utilisation",
  'layout.footer.privacy': 'Politique de confidentialité',
  'layout.footer.cookies': 'Politique de cookies',
  'layout.footer.tagline': 'Aura Nota · capture et extraction de factures fiscales',

  // ---------------------------------------------------------------------------
  // consent — ConsentGate.tsx
  // ---------------------------------------------------------------------------
  'consent.title': 'Consentement LGPD',
  'consent.intro': 'Pour continuer à utiliser Aura Nota, vous devez accepter la version en vigueur ({version}) des documents légaux suivants :',
  'consent.acceptLabel': "J'ai lu et j'accepte les Conditions d'utilisation, la Politique de confidentialité et la Politique de cookies.",
  'consent.submit': 'Accepter et continuer',
  'consent.submitting': 'Enregistrement...',
  'consent.error.check': 'Erreur lors de la vérification du consentement.',
  'consent.error.mustAccept': 'Vous devez accepter les documents légaux pour continuer.',
  'consent.error.register': 'Erreur lors de l\'enregistrement du consentement.',

  // ---------------------------------------------------------------------------
  // errorBoundary — ErrorBoundary.tsx
  // ---------------------------------------------------------------------------
  'errorBoundary.title': 'Une erreur est survenue',
  'errorBoundary.message': 'Une erreur inattendue s\'est produite. Essayez de recharger la page.',
  'errorBoundary.reload': 'Recharger',

  // ---------------------------------------------------------------------------
  // account — Account.tsx
  // ---------------------------------------------------------------------------
  'account.title': 'Mon compte',
  'account.emailLabel': 'E-mail :',
  'account.statusLabel': 'Statut :',
  'account.statusActive': 'Actif',
  'account.statusInactive': 'Inactif',
  'account.historyTitle': 'Historique de consentement',
  'account.legalDocsIntro': 'Documents légaux en vigueur : ',
  'account.loading': 'Chargement...',
  'account.error.load': 'Erreur lors du chargement de l\'historique.',
  'account.empty': 'Aucun consentement enregistré.',
  'account.col.document': 'Document',
  'account.col.version': 'Version',
  'account.col.accepted': 'Accepté',
  'account.col.date': 'Date',
  'account.col.ip': 'IP',
  // Edition des donnees personnelles ("Mes informations") + mot de passe.
  'account.profile.title': 'Mes informations',
  'account.profile.name': 'Nom',
  'account.profile.namePlaceholder': 'Votre nom complet',
  'account.profile.nameRequired': 'Veuillez saisir un nom valide.',
  'account.profile.language': 'Langue',
  'account.profile.email': 'E-mail',
  'account.profile.emailNote': 'Pour changer l’e-mail, contactez le support/administrateur.',
  'account.profile.save': 'Enregistrer',
  'account.profile.saving': 'Enregistrement...',
  'account.profile.saved': 'Informations mises à jour avec succès.',
  'account.profile.error': 'Erreur lors de l’enregistrement.',
  'account.password.title': 'Changer le mot de passe',
  'account.password.current': 'Mot de passe actuel',
  'account.password.new': 'Nouveau mot de passe',
  'account.password.confirm': 'Confirmer le nouveau mot de passe',
  'account.password.hint': '8 caractères minimum, avec au moins 1 lettre et 1 chiffre.',
  'account.password.submit': 'Changer le mot de passe',
  'account.password.submitting': 'Modification...',
  'account.password.success': 'Mot de passe modifié avec succès.',
  'account.password.error': 'Erreur lors du changement de mot de passe.',
  'account.password.mismatch': 'La confirmation ne correspond pas au nouveau mot de passe.',
  'account.password.tooShort': 'Le nouveau mot de passe doit contenir au moins 8 caractères.',

  // ---------------------------------------------------------------------------
  // audit — Audit.tsx
  // ---------------------------------------------------------------------------
  'audit.title': 'Audit LGPD',
  'audit.subtitle': 'Journal des événements de traitement, d\'accès et de consentement.',
  'audit.exportCsv': 'Exporter CSV',
  'audit.exportJson': 'Exporter JSON',
  'audit.compliance.title': 'Conformité LGPD',
  'audit.compliance.pii': 'PII anonymisé : les noms de fichiers et les hachages sont stockés sans données personnelles directes',
  'audit.compliance.retention': 'Rétention : les journaux d\'audit sont immuables et conservés selon la politique de rétention',
  'audit.compliance.dsar': 'DSAR : droits du titulaire (accès, suppression, portabilité) disponibles via l\'API',
  'audit.filter.eventType': 'Type d\'événement',
  'audit.filter.from': 'De',
  'audit.filter.to': 'À',
  'audit.filter.all': 'Tous',
  'audit.filter.action.documentUpload': 'Téléversement de document',
  'audit.filter.action.documentUploadDuplicate': 'Téléversement en double',
  'audit.filter.action.documentProcess': 'Traitement',
  'audit.filter.action.documentDelete': 'Suppression',
  'audit.filter.action.consentAccepted': 'Consentement',
  'audit.filter.action.login': 'Connexion',
  'audit.filter.action.logout': 'Déconnexion',
  'audit.loading': 'Chargement...',
  'audit.error.load': 'Erreur lors du chargement de l\'audit.',
  'audit.empty': 'Aucun événement d\'audit trouvé.',
  'audit.eventCount': '{count} événements',
  'audit.col.date': 'Date',
  'audit.col.event': 'Événement',
  'audit.col.resource': 'Ressource',
  'audit.col.details': 'Détails',
  'audit.col.user': 'Utilisateur',
  // Action labels (display in table)
  'audit.action.document_upload': 'Téléversement de document',
  'audit.action.document_upload_duplicate': 'Téléversement en double',
  'audit.action.document_process': 'Traitement',
  'audit.action.document_delete': 'Suppression de document',
  'audit.action.consent_accepted': 'Consentement accepté',
  'audit.action.login': 'Connexion',
  'audit.action.logout': 'Déconnexion',

  // ---------------------------------------------------------------------------
  // documents — Documents.tsx
  // ---------------------------------------------------------------------------
  'documents.title': 'Documents',
  'documents.view.grid': 'Grille',
  'documents.view.cards': 'Cartes',
  'documents.export.csv': 'Exporter CSV',
  'documents.export.excel': 'Exporter Excel',
  'documents.filter.type': 'Type',
  'documents.filter.status': 'Statut',
  'documents.filter.all': 'Tous',
  'documents.filter.from': 'De',
  'documents.filter.to': 'À',
  'documents.filter.importId': 'Import ID',
  'documents.filter.importIdPlaceholder': 'ex : 20260819-001',
  'documents.filter.button': 'Filtrer',
  'documents.loading': 'Chargement...',
  'documents.loadingDetails': 'Chargement des détails...',
  'documents.empty': 'Aucun document trouvé.',
  'documents.error.load': 'Erreur lors du chargement des documents.',
  'documents.error.loadDetail': 'Erreur lors du chargement du détail.',
  'documents.error.saveField': 'Erreur lors de l\'enregistrement du champ.',
  'documents.error.export': 'Erreur lors de l\'exportation.',

  // Status filter options
  'documents.status.concluido': 'Terminé',
  'documents.status.revisao': 'Révision',
  'documents.status.erro': 'Erreur',
  'documents.status.recebido': 'Reçu',

  // Fiscal column headers (grid)
  'documents.col.numero': 'Numéro',
  'documents.col.serie': 'Série',
  'documents.col.prestadorCnpj': 'Prestataire CNPJ',
  'documents.col.prestadorCnpjEmitente': "CNPJ de l'Émetteur",
  'documents.col.prestador': 'Prestataire',
  'documents.col.tomadorCnpj': 'Client CNPJ',
  'documents.col.tomadorCnpjDestinatario': 'CNPJ du Destinataire',
  'documents.col.tomador': 'Client',
  'documents.col.valorTotal': 'Valeur Totale',
  'documents.col.valorServico': 'Valeur Service',
  'documents.col.dataEmissao': 'Date d\'émission',
  'documents.col.municipio': 'Municipalité',
  'documents.col.codVerificacao': 'Code de vérification',
  'documents.col.descricao': 'Description',
  'documents.col.imPrestador': 'IM Prestataire',
  'documents.col.docType': 'Type de Document',
  'documents.col.importId': 'Import ID',
  'documents.col.origin': 'Origine',

  // Cards view headers
  'documents.cards.importId': 'Import ID',
  'documents.cards.file': 'Fichier',
  'documents.cards.type': 'Type',
  'documents.cards.status': 'Statut',
  'documents.cards.fields': 'Champs',
  'documents.cards.confidence': 'Confiance',
  'documents.cards.children': 'Enfants',
  'documents.cards.date': 'Envoyé',

  // Detail panel
  'documents.detail.close': 'Fermer',
  'documents.detail.downloading': 'Téléchargement...',
  'documents.detail.downloadJson': 'Télécharger JSON',
  'documents.detail.downloadXml': 'Télécharger XML',
  'documents.detail.downloadPdf': 'Télécharger PDF',
  'documents.detail.downloadFields': 'Télécharger les champs (CSV)',
  'documents.detail.type': 'Type',
  'documents.detail.origin': 'Origine',
  'documents.detail.status': 'Statut',
  'documents.detail.avgConfidence': 'Confiance moyenne',
  'documents.detail.importId': "ID d'importation",
  'documents.detail.needsReview': 'Révision requise : {reason}',
  'documents.detail.reviewReasonDefault': 'Raison non spécifiée',
  'documents.detail.error': 'Erreur : {error}',
  'documents.detail.extractedFields': 'Champs extraits',
  'documents.detail.col.field': 'Champ',
  'documents.detail.col.value': 'Valeur',
  'documents.detail.col.confidence': 'Confiance',
  'documents.detail.col.origin': 'Origine',
  'documents.detail.col.raw': 'Raw',
  'documents.detail.metadata': 'Métadonnées',
  'documents.detail.children': 'Documents enfants ({count})',
  'documents.detail.childError': 'erreur',
  'documents.detail.processingLog': "Journal d'audit du traitement",

  // Editable cell tooltip
  'documents.cell.tooltip': '{field} — confiance {conf}% (double-cliquez pour modifier)',

  // Provenance modal
  'documents.provenance.title': 'Chaîne d\'origine',
  'documents.provenance.close': 'Fermer',
  'documents.provenance.noChain': 'Pas de container_chain (fichier terminal direct).',
  'documents.delete': 'Supprimer',
  'documents.deleteConfirm': 'Etes-vous sur de vouloir deplacer ce document vers la corbeille ? Vous pourrez le recuperer pendant 30 jours.',
  'documents.trash': 'Corbeille',
  'documents.restore': 'Restaurer',
  'documents.daysUntilPurge': 'Jours avant suppression permanente',
  'documents.timeRemaining': 'Temps restant : {days} jours avant suppression permanente',
  'documents.trashEmpty': 'La corbeille est vide.',
  'documents.trashDeletedAt': 'Supprime le',
  'documents.actions': 'Actions',
  'documents.error.delete': 'Erreur lors du deplacement vers la corbeille.',
  'documents.error.restore': 'Erreur lors de la restauration du document.',

  // Batch selection (Feature 2)
  'documents.batch.selectedCount': '{count} sélectionnés',
  'documents.batch.selectAll': 'Tout sélectionner',
  'documents.batch.deleteTitle': 'Supprimer les documents',
  'documents.batch.deleteConfirm': 'Êtes-vous sûr de vouloir supprimer {count} document(s) ? Ils seront déplacés vers la corbeille et pourront être récupérés pendant 30 jours.',
  'documents.batch.deletePartialError': 'Erreur lors de la suppression de {failed} sur {total} document(s).',

  // ---------------------------------------------------------------------------
  // upload — Upload.tsx
  // ---------------------------------------------------------------------------
  'upload.title': 'Téléversement de documents',
  'upload.subtitle': 'Envoyez des PDF, XML, e-mails (.eml/.msg), ZIP, HTML ou images pour l\'extraction automatique des champs fiscaux.',
  'upload.dropzone.text': 'Glissez les fichiers ici ou cliquez pour sélectionner',
  'upload.dropzone.formats': 'Formats : {formats} — Max 25 Mo',
  'upload.process': 'Traiter ({count} en attente)',
  'upload.processing': 'Traitement...',
  'upload.clear': 'Effacer',
  'upload.summary': '{done} terminés, {errors} erreurs, {pending} en attente',
  'upload.filesTitle': 'Fichiers envoyés',
  'upload.viewResult': 'Voir le résultat',
  'upload.remove': 'Retirer',
  'upload.result.type': 'Type : {type}',
  'upload.result.origin': 'Origine : {origin}',
  'upload.result.fields': 'Champs : {count}',
  'upload.result.errors': 'Erreurs : {count}',
  'upload.result.duplicate': 'Doublon',
  'upload.error.batchNotFound': 'Résultat introuvable dans le lot.',
  'upload.error.cancelledDuplicate': 'Annulé (doublon non traité)',
  'upload.error.timeout': 'Délai dépassé pour le traitement.',
  // Issue #279: Mode lot pour les envois de 3+ fichiers.
  'upload.batch.submitted': 'Lot envoyé. Vous serez averti à la fin.',
  'upload.batch.inProgress': 'Lot en cours: {done}/{total} terminés',
  'upload.batch.complete': 'Lot terminé: {success} succès, {errors} erreurs',
  'upload.batch.blocked': 'Attendez la fin du lot actuel',
  'upload.batch.networkError': 'Le lot peut être en cours de traitement sur le serveur. Vérifiez la liste des documents avant de renvoyer.',
  'upload.batch.checkStatus': 'Vérifier le statut',

  // Status badge labels
  'upload.status.pending': 'En attente',
  'upload.status.uploading': 'Téléversement...',
  'upload.status.processing': 'Traitement...',
  'upload.status.done': 'Terminé',
  'upload.status.error': 'Erreur',

  // Result panel
  'upload.result.title': "Résultat de l'extraction",
  'upload.result.close': 'Fermer',
  'upload.result.file': 'Fichier',
  'upload.result.typeLabel': 'Type',
  'upload.result.originLabel': 'Origine',
  'upload.result.time': 'Durée',
  'upload.result.needsReview': 'Révision requise : {reason}',
  'upload.result.reviewReasonDefault': 'Raison non spécifiée',
  'upload.result.error': 'Erreur : {error}',
  'upload.result.extractedFields': 'Champs extraits',
  'upload.result.col.field': 'Champ',
  'upload.result.col.value': 'Valeur',
  'upload.result.col.confidence': 'Confiance',
  'upload.result.col.origin': 'Origine',
  'upload.result.metadata': 'Métadonnées',
  'upload.result.children': 'Documents enfants ({count})',
  'upload.result.childError': 'erreur',

  // Duplicate modal (single file)
  'upload.duplicate.title': 'NF en double détectée',
  'upload.duplicate.intro': 'Cette NF a déjà été traitée précédemment.',
  'upload.duplicate.type.file': 'Fichier identique',
  'upload.duplicate.type.data': 'Même NF (données)',
  'upload.duplicate.importId': 'Import ID',
  'upload.duplicate.type': 'Type',
  'upload.duplicate.file': 'Fichier',
  'upload.duplicate.processedAt': 'Traitée le',
  'upload.duplicate.whatToDo': 'Que voulez-vous faire ?',
  'upload.duplicate.replace': 'Remplacer',
  'upload.duplicate.replaceDesc': 'supprime l\'enregistrement précédent et en crée un nouveau',
  'upload.duplicate.archive': 'Archiver',
  'upload.duplicate.archiveDesc': 'conserve l\'enregistrement précédent archivé et en crée un nouveau',
  'upload.duplicate.duplicate': 'Dupliquer',
  'upload.duplicate.duplicateDesc': 'crée un nouvel enregistrement sans modifier le précédent',
  'upload.duplicate.cancel': 'Annuler',
  'upload.duplicate.cancelDesc': 'ne pas traiter',
  'upload.duplicate.processing': 'Traitement...',

  // Batch duplicate modal
  'upload.batchDuplicate.title': '{count} fichier(s) en double trouvé(s)',
  'upload.batchDuplicate.intro': 'Les fichiers ci-dessous ont déjà été traités précédemment. Choisissez une action pour chacun. Les fichiers non dupliqués seront traités normalement.',
  'upload.batchDuplicate.type.file': 'Fichier identique',
  'upload.batchDuplicate.type.data': 'Même NF (données)',
  'upload.batchDuplicate.existingImportId': 'Import ID existant',
  'upload.batchDuplicate.existingFile': 'Fichier existant',
  'upload.batchDuplicate.processedAt': 'Traité le',
  'upload.batchDuplicate.replace': 'Remplacer',
  'upload.batchDuplicate.replaceDesc': 'supprime le précédent et crée un nouveau',
  'upload.batchDuplicate.archive': 'Archiver',
  'upload.batchDuplicate.archiveDesc': 'archive le précédent et crée un nouveau',
  'upload.batchDuplicate.duplicate': 'Dupliquer',
  'upload.batchDuplicate.duplicateDesc': 'crée un nouveau sans modifier le précédent',
  'upload.batchDuplicate.remove': 'Retirer',
  'upload.batchDuplicate.removeDesc': 'supprime l\'enregistrement précédent (admin)',
  'upload.batchDuplicate.cancel': 'Annuler',
  'upload.batchDuplicate.cancelDesc': 'ne pas traiter',
  'upload.batchDuplicate.cancelAll': 'Tout annuler',
  'upload.batchDuplicate.confirm': 'Confirmer les décisions',
  'upload.batchDuplicate.processing': 'Traitement...',

  // Notifications (Issue #281)
  'notifications.title': 'Notifications',
  'notifications.empty': 'Aucune notification',
  'notifications.markAllRead': 'Tout marquer comme lu',
  'notifications.batchComplete': 'Lot terminé',
  'notifications.justNow': 'à l\'instant',
  'notifications.minutesAgo': 'il y a {n} min',
  'notifications.hoursAgo': 'il y a {n} h',
  'notifications.daysAgo': 'il y a {n} j',  // Sprint 7: Billing / Pricing / Signup

  'layout.nav.pricing': 'Tarifs',
  'pricing.title': 'Choisissez le plan idéal pour vous',
  'pricing.subtitle': 'Commencez gratuitement et évoluez selon vos besoins. Sans carte de crédit.',
  'pricing.unlimited': 'Nous contacter',
  'pricing.free': 'Gratuit',
  'pricing.month': 'mois',
  'pricing.unlimitedDocs': 'Documents illimités',
  'pricing.docsPerMonth': '{count} documents/mois',
  'pricing.popular': 'Le plus populaire',
  'pricing.feat.upload': 'Téléversement de documents',
  'pricing.feat.exportCsv': 'Export CSV',
  'pricing.feat.multiUser': 'Utilisateurs multiples',
  'pricing.feat.audit': 'Journal d\'audit',
  'pricing.feat.apiAccess': 'Accès API',
  'pricing.feat.prioritySupport': 'Support prioritaire',
  'pricing.ctaFree': 'Commencer gratuitement',
  'pricing.ctaPaid': 'S\'abonner',
  'pricing.processing': 'Traitement...',
  'pricing.pixTitle': 'Payer via PIX',
  'pricing.pixInstructions': 'Scannez le QR code ci-dessous avec votre banque pour payer l\'abonnement.',
  'pricing.goToBilling': 'Aller à la facturation',
  // Issue #593: plans Single/Team/Enterprise (contrat #592) + tableau
  // comparatif sur la meme page.
  'pricing.ctaEnterprise': 'Parler aux ventes',
  'pricing.enterpriseMailSubject': 'Aura Nota — Plan Enterprise',
  'pricing.users.one': '1 utilisateur',
  'pricing.users.upTo': 'Jusqu\'à {count} utilisateurs',
  'pricing.users.unlimited': 'Utilisateurs illimités',
  'pricing.feat.exportJson': 'Exporter JSON',
  'pricing.feat.emailCapture': 'Capture par e-mail dédié',
  'pricing.feat.accountant': 'Utilisateur comptable',
  'pricing.feat.onboarding': 'Onboarding assisté',
  'comparison.title': 'Comparaison des plans',
  'comparison.subtitle': 'Toutes les fonctionnalités, côte à côte.',
  'comparison.feature': 'Fonctionnalité',
  'comparison.unlimited': 'Illimité',
  'comparison.row.docs': 'Documents par mois',
  'comparison.row.users': 'Utilisateurs inclus',
  'comparison.row.accountant': 'Utilisateur comptable',
  'comparison.row.emailUpload': 'Capture par e-mail dédié et téléversement manuel',
  'comparison.row.exportJson': 'Export JSON',
  'comparison.row.exportCsv': 'Export CSV',
  'comparison.row.multiUser': 'Multi-utilisateur (équipe)',
  'comparison.row.audit': 'Piste d\'audit (LGPD)',
  'comparison.row.apiAccess': 'Accès API',
  'comparison.row.prioritySupport': 'Support prioritaire',
  'comparison.row.onboarding': 'Onboarding assisté',
  'signup.title': 'Créer un compte',
  'signup.subtitle': 'Commencez à utiliser Aura Nota gratuitement.',
  'signup.name': 'Nom',
  'signup.company': 'Entreprise',
  'signup.email': 'E-mail',
  'signup.password': 'Mot de passe',
  'signup.passwordHint': 'Minimum 8 caractères, 1 lettre et 1 chiffre.',
  'signup.submit': 'Créer le compte',
  'signup.submitting': 'Création...',
  'signup.error': 'Impossible de créer le compte.',
  'signup.haveAccount': 'Vous avez déjà un compte ?',
  'signup.loginLink': 'Se connecter',
  'signup.successTitle': 'Compte créé !',
  'signup.successBody': 'Vérifiez votre e-mail pour activer votre compte. Après activation, vous pourrez vous connecter.',
  'signup.goLogin': 'Aller à la connexion',
  'billing.title': 'Facturation',
  'billing.currentPlan': 'Plan actuel',
  'billing.planLabel': 'Plan',
  'billing.statusLabel': 'Statut',
  'billing.status.active': 'Actif',
  'billing.status.pending_payment': 'Paiement en attente',
  'billing.status.suspended': 'Suspendu',
  'billing.status.cancelled': 'Annulé',
  'billing.renewsOn': 'Renouvellement le',
  'billing.paymentMethod': 'Méthode de paiement',
  'billing.usage': 'Utilisation ce mois',
  'billing.used': '{used} sur {limit} documents',
  'billing.remaining': '{count} restants',
  'billing.unlimited': 'Illimité',
  'billing.resetsOn': 'Réinitialisé le {date}',
  'billing.pendingPayment': 'Paiement en attente',
  'billing.invoiceAmount': 'R$ {amount}',
  'billing.dueDate': 'Échéance : {date}',
  'billing.pixTitle': 'Payer via PIX',
  'billing.pixInstructions': 'Scannez le QR code avec votre banque. Après le paiement, un admin confirmera et votre plan sera activé.',
  'billing.invoiceId': 'Facture : {id}',
  'billing.refresh': 'Actualiser',
  'billing.upgradePro': 'Passer à Pro',
  'billing.viewPlans': 'Voir les plans et passer à un plan supérieur',
  'billing.cancel': 'Annuler l\'abonnement',
  'billing.cancelConfirm': 'Êtes-vous sûr de vouloir annuler votre abonnement ?',
  'billing.processing': 'Traitement...',
  'signup.consentPrefix': 'J\'ai lu et j\'accepte les',
  'signup.consentAnd': 'et la',
  'signup.consentRequired': 'Vous devez accepter les Conditions d\'utilisation et la Politique de confidentialité pour créer un compte.',

  'layout.nav.sefaz': 'Rechercher par Clé',
  'sefaz.title': 'Rechercher NF-e par Clé d\'Accès',
  'sefaz.tab.individual': 'Individuel',
  'sefaz.tab.batch': 'Lot (Excel)',
  'sefaz.individual.label': 'Clé d\'Accès (44 chiffres)',
  'sefaz.individual.invalid': 'Clé invalide : doit avoir 44 chiffres avec chiffre de contrôle valide',
  'sefaz.individual.valid': 'Clé valide',
  'sefaz.individual.search': 'Rechercher',
  'sefaz.individual.result': 'Résultat de la recherche',
  'sefaz.individual.goToDocs': 'Voir le document dans Documents',
  'sefaz.status': 'Statut',
  'sefaz.batch.downloadTemplate': 'Télécharger le Modèle Excel',
  'sefaz.batch.dropHere': 'Glissez un fichier .xlsx ici ou cliquez pour sélectionner',
  'sefaz.batch.errorFormat': 'Le fichier doit être .xlsx',
  'sefaz.batch.progress': 'Progression du lot',
  'sefaz.batch.total': 'Total',
  'sefaz.batch.processed': 'Traitées',
  'sefaz.batch.success': 'Succès',
  'sefaz.batch.error': 'Erreurs',
  'sefaz.batch.status': 'Statut',
  'sefaz.batch.goToDocs': 'Voir les documents créés',
  'sefaz.batch.history': 'Lots précédents',
  'sefaz.batch.export': 'Exporter les résultats',
  'layout.nav.sefazGroup': 'Fiscal / SEFAZ',
  'sefaz.nav.status': 'Statut du service',
  'sefaz.nav.consulta': 'Recherche par clé',
  'sefaz.nav.dfe': 'Distribution DF-e par NSU',
  'sefaz.nav.certs': 'Certificats',
  'sefaz.statusPage.title': 'Statut du service SEFAZ',
  'sefaz.statusPage.ufLabel': 'UF',
  'sefaz.statusPage.tab.nfe': 'NF-e',
  'sefaz.statusPage.tab.cte': 'CT-e',
  'sefaz.statusPage.tab.mdfe': 'MDF-e',
  'sefaz.statusPage.consult': 'Consulter',
  'sefaz.statusPage.cstat': 'cStat',
  'sefaz.statusPage.xmotivo': 'Motif',
  'sefaz.statusPage.uf': 'UF',
  'sefaz.statusPage.timestamp': 'Date/heure',
  'sefaz.statusPage.rateLimited': 'Limite de requêtes dépassée. Réessayez dans {s}s.',
  'sefaz.statusPage.unavailable': 'Le service SEFAZ est momentanément indisponible. Veuillez réessayer dans un instant.',
  'sefaz.gated.title': 'Nécessite un certificat A1 configuré',
  'sefaz.gated.body': 'Cette recherche nécessite un certificat numérique A1 lié à l’organisation. Enregistrez-le dans Fiscal/SEFAZ > Certificats.',
  'sefaz.gated.cta': 'Aller aux Certificats',
  'sefaz.dfe.title': 'Distribution DF-e par NSU',
  'sefaz.dfe.nsuLabel': 'Dernier NSU (15 chiffres)',
  'sefaz.certs.title': 'Gestion des certificats A1',
  'sefaz.certs.badge': 'Bientôt disponible',
  'sefaz.certs.body': 'Vous pourrez ici enregistrer et gérer le certificat numérique A1 de l’organisation, requis pour les recherches SEFAZ authentifiées (recherche par clé et distribution DF-e).',
  // Sprint 14 (issue #482): pagina real de custodia de certificados A1.
  'sefaz.certs.subtitle': 'Certificat numérique A1 (e-CNPJ) utilisé pour les recherches SEFAZ authentifiées.',
  'sefaz.certs.retry': 'Réessayer',
  'sefaz.certs.tab.detail': 'Certificat',
  'sefaz.certs.tab.history': 'Historique',
  'sefaz.certs.empty.title': 'Aucun certificat enregistré',
  'sefaz.certs.empty.body': 'Envoyez le certificat numérique A1 (.pfx/.p12) de l’organisation pour activer les recherches SEFAZ authentifiées.',
  'sefaz.certs.empty.memberHint': 'L’organisation n’a pas encore de certificat numérique enregistré. Demandez à un administrateur de l’envoyer.',
  'sefaz.certs.empty.cta': 'Envoyer le certificat',
  'sefaz.certs.member.title': 'Certificat numérique de l’organisation',
  'sefaz.certs.member.absent': 'Aucun certificat numérique enregistré.',
  'sefaz.certs.member.configured': 'Certificat numérique configuré et actif.',
  'sefaz.certs.member.expiring': 'Le certificat numérique expire dans {n} jour(s).',
  'sefaz.certs.member.expired': 'Le certificat numérique est expiré.',
  'sefaz.certs.member.hint': 'La gestion du certificat est réservée aux administrateurs de l’organisation.',
  'sefaz.certs.expiredBanner': 'Le certificat numérique est expiré — les recherches SEFAZ sont indisponibles jusqu’à la rotation.',
  'sefaz.certs.expiredCta': 'Renouveler maintenant',
  'sefaz.certs.meta.title': 'Certificat en custodie',
  'sefaz.certs.meta.cn': 'Nom (CN)',
  'sefaz.certs.meta.issuer': 'Émetteur',
  'sefaz.certs.meta.serial': 'Numéro de série',
  'sefaz.certs.meta.cnpj': 'CNPJ',
  'sefaz.certs.meta.validFrom': 'Valide depuis',
  'sefaz.certs.meta.validTo': 'Valide jusqu’au',
  'sefaz.certs.meta.fingerprint': 'Empreinte SHA-256',
  'sefaz.certs.meta.uploadedAt': 'Envoyé le',
  'sefaz.certs.meta.uploadedBy': 'Envoyé par',
  'sefaz.certs.meta.lastSession': 'Dernière session MCP',
  'sefaz.certs.status.ativo': 'Actif',
  'sefaz.certs.status.ausente': 'Aucun certificat',
  'sefaz.certs.status.vencendo': 'Expire dans {n} jours',
  'sefaz.certs.status.expirado': 'Expiré',
  'sefaz.certs.status.pendente': 'En attente de consentement',
  'sefaz.certs.status.removido': 'Supprimé',
  'sefaz.certs.actions.rotate': 'Renouveler le certificat',
  'sefaz.certs.actions.remove': 'Supprimer le certificat',
  'sefaz.certs.upload.titleCreate': 'Envoyer le certificat A1',
  'sefaz.certs.upload.titleRotate': 'Renouveler le certificat A1',
  'sefaz.certs.upload.dropzone': 'Glissez le fichier du certificat ici ou cliquez pour sélectionner',
  'sefaz.certs.upload.formats': 'Formats acceptés : .pfx ou .p12 — maximum 64 Ko',
  'sefaz.certs.upload.changeFile': 'cliquez pour changer de fichier',
  'sefaz.certs.upload.fileErrorExt': 'Fichier invalide : envoyez un certificat .pfx ou .p12 (A1).',
  'sefaz.certs.upload.fileErrorSize': 'Le fichier dépasse la limite de 64 Ko.',
  'sefaz.certs.upload.passwordLabel': 'Mot de passe du certificat',
  'sefaz.certs.upload.passwordHint': 'Le mot de passe sert uniquement à valider le certificat et est stocké chiffré — jamais affiché ni enregistré dans le navigateur.',
  'sefaz.certs.upload.submitCreate': 'Valider et garder en custodie',
  'sefaz.certs.upload.submitRotate': 'Valider et renouveler',
  'sefaz.certs.upload.successCreate': 'Certificat envoyé et conservé avec succès.',
  'sefaz.certs.upload.successRotate': 'Certificat renouvelé avec succès.',
  'sefaz.certs.consent.text': 'J’autorise Aura Nota à conserver le certificat numérique A1 de l’organisation (CNPJ {cnpj}) sous forme chiffrée, à l’utiliser exclusivement pour des recherches fiscales en mon nom via des sessions transitoires, et je reconnais pouvoir révoquer cette autorisation et supprimer le certificat à tout moment.',
  'sefaz.certs.consent.textNoCnpj': 'J’autorise Aura Nota à conserver le certificat numérique A1 de l’organisation sous forme chiffrée, à l’utiliser exclusivement pour des recherches fiscales en mon nom via des sessions transitoires, et je reconnais pouvoir révoquer cette autorisation et supprimer le certificat à tout moment.',
  'sefaz.certs.consent.linkLabel': 'Lire les conditions de custodie',
  'sefaz.certs.mismatch.title': 'CNPJ divergent',
  'sefaz.certs.mismatch.body': 'Le CNPJ du nouveau certificat ne correspond pas au CNPJ de l’organisation. Ne confirmez que si l’organisation a réellement changé de CNPJ ou si ce certificat appartient au bon titulaire.',
  'sefaz.certs.mismatch.confirm': 'Confirmer la divergence et renouveler',
  'sefaz.certs.remove.title': 'Supprimer le certificat',
  'sefaz.certs.remove.impact': 'Impact : les recherches fiscales (SEFAZ/RFB) de cette organisation deviennent indisponibles jusqu’à l’envoi d’un nouveau certificat. Le matériel chiffré est effacé immédiatement et la session MCP est fermée.',
  'sefaz.certs.remove.confirmLabel': 'Je comprends l’impact et confirme la suppression du certificat en custodie.',
  'sefaz.certs.remove.confirm': 'Supprimer définitivement',
  'sefaz.certs.remove.success': 'Certificat retiré de la custodie.',
  'sefaz.certs.history.col.action': 'Action',
  'sefaz.certs.history.col.user': 'Utilisateur',
  'sefaz.certs.history.col.timestamp': 'Date/heure',
  'sefaz.certs.history.col.ip': 'IP',
  'sefaz.certs.history.empty': 'Aucun événement enregistré pour ce certificat.',
  'sefaz.certs.history.prev': 'Précédent',
  'sefaz.certs.history.next': 'Suivant',
  'sefaz.certs.history.page': 'Page {page} sur {pages}',
  'sefaz.certs.history.action.cert_upload': 'Envoi de certificat',
  'sefaz.certs.history.action.cert_view': 'Consultation des métadonnées',
  'sefaz.certs.history.action.cert_rotate': 'Renouvellement de certificat',
  'sefaz.certs.history.action.cert_delete': 'Suppression de certificat',
  'sefaz.certs.history.action.cert_use': 'Utilisation en recherche SEFAZ',
  'sefaz.certs.history.action.cert_consent_grant': 'Consentement enregistré',
  'sefaz.certs.history.action.cert_consent_revoke': 'Consentement révoqué',
  'sefaz.certs.history.action.cert_session_open': 'Session MCP ouverte',
  'sefaz.certs.error.invalidPfx': 'Mot de passe du certificat incorrect ou fichier invalide.',
  'sefaz.certs.error.invalidChain': 'Le certificat n’est pas A1 ICP-Brasil (e-CPF, A3 ou auto-signés non acceptés).',
  'sefaz.certs.error.expired': 'Certificat expiré — envoyez un certificat valide.',
  'sefaz.certs.error.cnpjMismatch': 'Le CNPJ du certificat ne correspond pas au CNPJ de l’organisation.',
  'sefaz.certs.error.rateLimited': 'Limite de tentatives dépassée. Réessayez dans {min} min.',
  'sefaz.certs.error.uploadDisabled': 'L’envoi de certificats est désactivé dans cet environnement.',
  'sefaz.certs.error.noOrgCnpj': 'Enregistrez le CNPJ de l’organisation avant d’envoyer le certificat.',
  'sefaz.certs.error.pfxTooLarge': 'Le fichier du certificat dépasse la limite acceptée.',
  'sefaz.certs.error.alreadyExists': 'Un certificat est déjà en custodie — utilisez le renouvellement pour le remplacer.',
  'sefaz.certs.error.consentRequired': 'Vous devez accepter les conditions de custodie pour continuer.',
  'sefaz.certs.error.confirmRequired': 'Confirmez l’opération pour continuer.',
  'sefaz.certs.error.unavailable': 'Service de recherche fiscale indisponible. Réessayez dans un instant.',
  'sefaz.certs.error.forbidden': 'Vous n’avez pas la permission pour cette action.',
  'sefaz.certs.error.validation': 'Données du certificat invalides.',
  'sefaz.certs.error.generic': 'Impossible de terminer l’opération.',

  // catalogo — catalogue collaboratif municipalités/fournisseurs (S10-T06)
  'layout.nav.catalogo': 'Municipalités',
  'catalogo.title': 'Catalogue des municipalités',
  'catalogo.subtitle': 'Mappage collaboratif municipalité → fournisseur NFS-e.',
  'catalogo.stats.municipios': 'Municipalités couvertes',
  'catalogo.stats.provedores': 'Fournisseurs pris en charge',
  'catalogo.stats.ufs': 'États couverts',
  'catalogo.stats.pendentes': 'Suggestions en attente',
  'catalogo.table.title': 'Municipalités',
  'catalogo.table.ibge': 'IBGE',
  'catalogo.table.nome': 'Municipalité',
  'catalogo.table.uf': 'État',
  'catalogo.table.provedor': 'Fournisseur',
  'catalogo.table.agregador': 'Agrégateur',
  'catalogo.table.empty': 'Aucune municipalité trouvée.',
  'catalogo.filter.uf': 'État',
  'catalogo.filter.provedor': 'Fournisseur',
  'catalogo.filter.busca': 'Rechercher une municipalité',
  'catalogo.export': 'Exporter JSON',
  'catalogo.import': 'Importer JSON',
  'catalogo.import.result': 'Import : {created} créés, {updated} mis à jour ({total} éléments).',
  'catalogo.suggest.title': 'Suggérer un mappage',
  'catalogo.suggest.ibge': 'Code IBGE',
  'catalogo.suggest.nome': 'Municipalité',
  'catalogo.suggest.uf': 'État',
  'catalogo.suggest.provedor': 'Fournisseur',
  'catalogo.suggest.agregador': 'Agrégateur (optionnel)',
  'catalogo.suggest.justificativa': 'Justification (optionnelle)',
  'catalogo.suggest.submit': 'Envoyer la suggestion',
  'catalogo.suggest.success': 'Suggestion envoyée pour modération.',
  'catalogo.sugestoes.title': 'Suggestions',
  'catalogo.sugestoes.empty': 'Aucune suggestion.',
  'catalogo.sugestoes.status.pendente': 'En attente',
  'catalogo.sugestoes.status.aprovada': 'Approuvée',
  'catalogo.sugestoes.status.rejeitada': 'Rejetée',
  'catalogo.moderation.actions': 'Actions',
  'catalogo.moderation.approve': 'Approuver',
  'catalogo.moderation.reject': 'Rejeter',
  'catalogo.moderation.rejectPrompt': 'Motif du rejet (optionnel) :',
  'catalogo.history.title': 'Historique du catalogue',
  'catalogo.history.action': 'Action',
  'catalogo.history.action.create': 'Création',
  'catalogo.history.action.update': 'Mise à jour',
  'catalogo.history.action.delete': 'Suppression',
  'catalogo.history.origem.admin': 'Édition directe',
  'catalogo.history.origem.sugestao': 'Suggestion approuvée',
  'catalogo.history.origem.import': 'Import',
  'catalogo.history.empty': 'Aucune modification enregistrée.',
  'catalogo.error.generic': 'Impossible de terminer l’opération.',

  // ---------------------------------------------------------------------------
  // onboarding — assistant de configuration du tenant (S10-T07, US-S10-007)
  // ---------------------------------------------------------------------------
  'layout.nav.onboarding': 'Onboarding',
  'onboarding.title': 'Onboarding assisté',
  'onboarding.subtitle': 'Configurez l’organisation étape par étape : e-mail, communes, seuils et un tour de l’interface.',
  'onboarding.progress': '{done} étape(s) sur {total}',
  'onboarding.error.load': 'Erreur lors du chargement de la checklist d’onboarding.',
  'onboarding.error.action': 'Erreur lors de l’exécution de l’action.',
  'onboarding.step.email': 'E-mail',
  'onboarding.step.municipios': 'Communes',
  'onboarding.step.thresholds': 'Seuils',
  'onboarding.step.tour': 'Tour guidé',
  'onboarding.step.auto': 'détecté',
  'onboarding.step.autoHint': 'Étape déjà satisfaite par la configuration actuelle de l’organisation.',
  'onboarding.step.complete': 'Terminer l’étape',
  'onboarding.step.completeHint': 'Une étape ne peut être terminée que lorsque la configuration correspondante est déjà enregistrée.',
  'onboarding.step.done': 'Étape terminée',
  'onboarding.nav.prev': 'Retour',
  'onboarding.nav.next': 'Suivant',
  'onboarding.finish': 'Terminer l’onboarding',
  'onboarding.help.title': 'Aide',
  'onboarding.help.email': 'Configurez une boîte IMAP pour la capture automatique des notes et/ou le SMTP d’envoi. Après l’onboarding, gérez tout dans Paramètres → E-mail.',
  'onboarding.help.municipios': 'Sélectionnez les communes dont votre organisation reçoit des NFS-e. La sélection vient du catalogue collaboratif commune → fournisseur.',
  'onboarding.help.thresholds': 'Définissez les seuils de validation de l’extraction. Vous pourrez les ajuster ensuite dans Paramètres → Seuils.',
  'onboarding.help.tour': 'Le tour présente les principales zones de l’interface. Vous pouvez le sauter et terminer l’étape manuellement.',
  'onboarding.help.link.settingsEmail': 'Ouvrir les paramètres',
  'onboarding.help.link.settingsThresholds': 'Ouvrir les paramètres',
  'onboarding.help.link.catalogo': 'Ouvrir le catalogue des communes',
  'onboarding.email.title': 'E-mail (capture et envoi)',
  'onboarding.email.subtitle': 'Configurez la boîte IMAP surveillée et/ou le serveur SMTP de l’organisation, avec test de connexion.',
  'onboarding.email.imapDetected': 'IMAP configuré',
  'onboarding.email.smtpDetected': 'SMTP configuré',
  'onboarding.email.imapLegend': 'IMAP — capture des notes',
  'onboarding.email.imapHint': 'Boîte e-mail surveillée pour la capture automatique des NFS-e/factures.',
  'onboarding.email.smtpLegend': 'SMTP — envoi d’e-mails',
  'onboarding.email.smtpHint': 'Serveur SMTP pour l’envoi des invitations et notifications.',
  'onboarding.email.saveImap': 'Enregistrer et tester IMAP',
  'onboarding.email.imapSaved': 'IMAP enregistré.',
  'onboarding.email.saveSmtp': 'Enregistrer SMTP',
  'onboarding.email.smtpSaved': 'SMTP enregistré.',
  'onboarding.email.testSmtp': 'Tester la connexion SMTP',
  'onboarding.email.testOk': 'Test de connexion : {message}',
  'onboarding.email.testFail': 'Échec du test : {error}',
  'onboarding.email.tip.host': 'Adresse du serveur de messagerie (ex. : imap.exemple.com ou smtp.exemple.com).',
  'onboarding.email.tip.password': 'Mot de passe ou mot de passe d’application de la boîte. Stocké chiffré.',
  'onboarding.email.tip.testSmtp': 'Enregistrez le SMTP avant de tester — le test utilise la configuration déjà persistée.',
  'onboarding.municipios.title': 'Communes surveillées',
  'onboarding.municipios.subtitle': 'Sélectionnez dans le catalogue les communes dont votre organisation reçoit des NFS-e.',
  'onboarding.municipios.searchPlaceholder': 'Rechercher une commune par nom...',
  'onboarding.municipios.search': 'Rechercher',
  'onboarding.municipios.searching': 'Recherche...',
  'onboarding.municipios.empty': 'Aucune commune trouvée dans le catalogue.',
  'onboarding.municipios.selected': 'Sélectionnée',
  'onboarding.municipios.add': 'Ajouter',
  'onboarding.municipios.remove': 'Retirer',
  'onboarding.municipios.count': '{count} commune(s) sélectionnée(s).',
  'onboarding.municipios.save': 'Enregistrer la sélection',
  'onboarding.municipios.update': 'Mettre à jour la sélection',
  'onboarding.municipios.saved': 'Sélection enregistrée ({count} communes).',
  'onboarding.thresholds.title': 'Seuils de validation',
  'onboarding.thresholds.subtitle': 'Confiance minimale du VLM, approbation automatique et file de révision — valeurs par défaut déjà remplies.',
  'onboarding.thresholds.save': 'Enregistrer les seuils',
  'onboarding.thresholds.saved': 'Seuils enregistrés.',
  'onboarding.tour.title': 'Tour guidé de l’interface',
  'onboarding.tour.subtitle': 'Un parcours interactif des principales zones du système.',
  'onboarding.tour.start': 'Démarrer le tour',
  'onboarding.tour.next': 'Suivant',
  'onboarding.tour.prev': 'Précédent',
  'onboarding.tour.skip': 'Sauter le tour',
  'onboarding.tour.finish': 'Terminer',
  'onboarding.tour.counter': '{current}/{total}',
  'onboarding.tour.step.intro.title': 'Bienvenue sur Aura Nota',
  'onboarding.tour.step.intro.body': 'Ce tour rapide montre où se trouvent les zones principales : envoi, documents, catalogue et paramètres.',
  'onboarding.tour.step.upload.title': 'Envoi de documents',
  'onboarding.tour.step.upload.body': 'Envoyez ici les PDF, XML et images de NFS-e et factures — l’extraction est automatique.',
  'onboarding.tour.step.documents.title': 'Documents',
  'onboarding.tour.step.documents.body': 'Tous les documents capturés sont ici, avec le statut d’extraction et de révision.',
  'onboarding.tour.step.catalogo.title': 'Catalogue des communes',
  'onboarding.tour.step.catalogo.body': 'Consultez la couverture commune → fournisseur NFS-e et suggérez de nouveaux mappings.',
  'onboarding.tour.step.settings.title': 'Paramètres du tenant',
  'onboarding.tour.step.settings.body': 'Gérez les utilisateurs, fournisseurs, e-mail, rétention et seuils de l’organisation.',
  'onboarding.tour.step.done.title': 'Tour terminé',
  'onboarding.tour.step.done.body': 'C’est prêt ! Terminez l’étape pour finaliser la checklist d’onboarding.',
  'onboarding.done.title': 'Onboarding terminé !',
  'onboarding.done.body': 'L’organisation est configurée et prête à capturer des documents.',
  'onboarding.done.notified': '{count} partenaire(s) notifié(s) de la conclusion.',
  'onboarding.done.goUpload': 'Envoyer le premier document',
  'onboarding.done.goSettings': 'Ouvrir les paramètres',
};
